import { List, Map, fromJS } from 'immutable';

export function request(state, { id }) {
    id = parseInt(id, 10);

    const update = state.get('update') || Map();
    let user = update.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', undefined);

    return state.set(
        'update', update.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    const update = state.get('update') || Map();
    let user = update.get(id) || Map();

    user = user
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set(
        'update', update.set(id, user)
    );
}

export function finish(state, { id, customer }) {
    id = parseInt(id, 10);

    const update = state.get('update') || Map();
    let customerUpdate = update.get(id) || Map();

    customerUpdate = customerUpdate
        .set('state', 'FINISHED')
        .set('errors', undefined);

    const list = state.get('list') || Map();
    let customerEl = (list.get(id) || Map());

    const updatedCustomer = (customerEl.get('data') || Map()).merge(fromJS(customer));

    customerEl = customerEl.set(
        'data',
        updatedCustomer
    );
    const firstName = customer.firstName.hasOwnProperty('value') ? customer.firstName.value : customer.firstName;
    const surname = customer.surname.hasOwnProperty('value') ? customer.surname.value : customer.surname;
    customerEl = customerEl.set('name', firstName + ' ' + surname);

    // Get index of current customer in searched list and update it's properties
    const customerIdx = (
        state.getIn(['search', 'list']) &&
        state.getIn(['search', 'list']).size > 1 &&
        'findIndex' in state.getIn(['search', 'list'])
    ) ?
        state.getIn(['search', 'list'])
            .findIndex(cust => cust.get('id') === updatedCustomer.get('id')) : updatedCustomer.get('id');

    return state
        .set('update', update.set(id, customerUpdate))
        .set('list', list.set(id, customerEl))
        .setIn(['search', 'list', customerIdx], updatedCustomer);
}

export function clear(state) {
    return state.set('update', Map());
}
